G.BoardCandy = G.BoardCandy || {};

G.BoardCandy.ChestType = function() {
  G.BoardCandy.CandyType.call(this);
};

G.BoardCandy.ChestType.prototype = Object.create(G.BoardCandy.CandyType.prototype);

G.BoardCandy.ChestType.prototype.onHit = function() {
  G.sb("onChestOpen").dispatch(this.candy, this.getEditorSymbol());
  this.signals.removeCandy.dispatch();
};